import type { View } from "react-native";

import { Button } from "../../../../../../mads";
import { Information } from "../../../../../../mads/icons";
import { useI18n } from "../../../../../../shared/I18n";
import { useAccessibilityFocus } from "../../../../hooks/useAccessibilityFocus";
import { useModalContext } from "../context/ApplicantInsightsModalContextProvider";

import { colors } from "@indeed/ifl-tokens";
import React, { useRef } from "react";

export function ApplicantInsightsPopoverIcon() {
  const focus = useAccessibilityFocus();
  const gt = useI18n();
  const { setApplicantInsightsPopoverProps, dismissApplicantInsightsPopover } = useModalContext();
  const buttonRef = useRef<View>(null);

  const handleDismiss = () => {
    dismissApplicantInsightsPopover();
    if (buttonRef.current) {
      focus(buttonRef.current);
    }
  };

  return (
    <Button
      ref={buttonRef}
      variant="text"
      ariaLabel={gt.gettext("More information about applicant insights")}
      onPress={() => {
        setApplicantInsightsPopoverProps({
          isOpen: true,
          onDismiss: handleDismiss,
        });
      }}
      iconOnly={true}
      iconBefore={
        <Information
          variant={"stroke"}
          title={"info-logo"}
          color={colors.foreground.strong}
          aria-hidden
          size="xs"
        />
      }
    />
  );
}
